import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

/** Rend les enfants dans <body> (modales, popovers, toasts). */
export function Portal({ children }: { children: ReactNode }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
